import { type CanvasElementType, type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { type CanvasElementPropertiesWithVisibility } from '@blaze-shared/elements-domain';

export function arePropsWithVisibility<T extends PartialPropsOf<CanvasElementType>>(
  props: T | undefined,
): props is T & CanvasElementPropertiesWithVisibility {
  return (
    props !== undefined &&
    'content' in props &&
    typeof props.content === 'object' &&
    'visible' in props.content
  );
}
